import monthlyAttendanceArchivesReducer from "./reducers";
export { default as monthlyAttendanceArchivesTypes } from "./types";
export { default as monthlyAttendanceArchivesOperations } from "./operations";
export default monthlyAttendanceArchivesReducer;
